import { gql } from '@apollo/client';

export const CREATE_POD = gql`
  mutation CreatePod($input: CreatePodInput!) {
    createPod(input: $input) {
      pod {
        id
        name
        type
        streamId
        podLeadId
        isActive
        stream {
          id
          name
        }
        podLead {
          id
          firstName
          lastName
        }
        createdAt
      }
      message
    }
  }
`;

export const UPDATE_POD = gql`
  mutation UpdatePod($where: PodWhereInput!, $input: UpdatePodInput!) {
    updatePod(where: $where, input: $input) {
      pod {
        id
        name
        type
        streamId
        podLeadId
        isActive
        stream {
          id
          name
        }
        podLead {
          id
          firstName
          lastName
        }
        updatedAt
      }
      message
    }
  }
`;

export const ASSIGN_PROJECT_TO_POD = gql`
  mutation AssignProjectToPod($input: AssignProjectToPodInput!) {
    assignProjectToPod(input: $input) {
      podProject {
        id
        podId
        projectId
        assignedAt
        project {
          id
          name
        }
      }
      message
    }
  }
`;

export const REMOVE_PROJECT_FROM_POD = gql`
  mutation RemoveProjectFromPod($where: RemoveProjectFromPodInput!) {
    removeProjectFromPod(where: $where)
  }
`;

export const ASSIGN_EMPLOYEE = gql`
  mutation AssignEmployee($input: AssignEmployeeInput!) {
    assignEmployee(input: $input) {
      assignment {
        id
        employeeId
        podId
        podRole
        allocationPct
        isPrimary
        startDate
        endDate
        employee {
          id
          firstName
          lastName
        }
        pod {
          id
          name
        }
      }
      message
    }
  }
`;

export const UPDATE_ASSIGNMENT = gql`
  mutation UpdateAssignment(
    $where: AssignmentWhereInput!
    $input: UpdateAssignmentInput!
  ) {
    updateAssignment(where: $where, input: $input) {
      assignment {
        id
        employeeId
        podId
        podRole
        allocationPct
        isPrimary
        startDate
        endDate
        employee {
          id
          firstName
          lastName
        }
        updatedAt
      }
      message
    }
  }
`;
